import { useFetch } from "@/hooks/useFetch";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

// Supplier field with one-tap autocomplete from the workspace Contacts book (team only).
export default function SupplierInput({ id, value, onChange, onPick, testid, ...rest }) {
  const { user } = useAuth();
  const team = user.role !== "client";
  const { data } = useFetch(team ? "/workspace/contacts" : null);
  const contacts = data?.contacts || [];
  const listId = `${id}-contacts`;
  const change = (e) => {
    onChange(e.target.value);
    const hit = contacts.find((c) => c.name === e.target.value || c.company === e.target.value);
    if (hit && onPick) onPick(hit);
  };
  return (
    <>
      <Input id={id} value={value} onChange={change} list={team && contacts.length ? listId : undefined} autoComplete="off" data-testid={testid} {...rest} />
      {team && contacts.length > 0 && (
        <datalist id={listId} data-testid={`${testid}-options`}>
          {contacts.map((c) => <option key={c.id} value={c.company || c.name}>{c.contact ? `${c.name} · ${c.contact}` : c.name}</option>)}
        </datalist>
      )}
    </>
  );
}
